<template>
    <div class="configurator__counter"><span>{{readySteps}} </span>шаг из <span>{{allSteps}}</span></div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "StepsCount",
    computed: {
        ... mapState([
            'moduleConfigurator'
        ]),
        allSteps() {
            return this.moduleConfigurator.steps.length ?? 0;
        },
        readySteps() {
            let count = 1;
            this.moduleConfigurator.steps.forEach(el => {
                if (el.showNext)
                    count++;
            });
            return count > this.allSteps ? this.allSteps : count;
        }
    }
}
</script>

<style scoped>

</style>